import { extendTheme } from "@chakra-ui/react";

export const createDynamicTheme = (branding: any) =>
  extendTheme({
    colors: {
      brand: {
        primary: branding.primary || "#075B5E",
        secondary: branding.secondary || "#F4631E",
        support: branding.support || "#309898",
        background: branding.background || "#FF9F00",
        tile: branding.tile || "#ffffff",
      },
    },
    styles: {
      global: {
        body: {
          bg: branding.background || "#FF9F00",
          color: "#2D2D2D",
        },
      },
    },
  });